import React from "react";

const ProcessSuccessful = ({ width = "259", height = "250" }) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 150 151"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M78.722 109.349c13.683 0 24.776-11.472 24.776-25.624 0-14.151-11.093-25.623-24.776-25.623-13.684 0-24.777 11.472-24.777 25.623 0 14.152 11.093 25.624 24.777 25.624z"
          fill="#fff"
        />
        <path
          d="M106.423 52.115c-1.429-2.977-3.37-5.154-5.816-6.551l-1.272-.636c-1.955-.846-4.151-1.207-6.59-1.102-.119.007-.243.013-.368.026-.131.007-.269.014-.4.027-3.311.269-6.846 1.495-10.61 3.665-3.757 2.177-7.298 5.03-10.603 8.584a64.092 64.092 0 00-8.636 11.652 63.99 63.99 0 00-4.131 8.512c-.007.013-.007.02-.013.033a59.187 59.187 0 00-1.666 4.721 51.898 51.898 0 00-.734 2.603c-.007.013-.007.026-.007.04-.944 3.691-1.403 7.272-1.403 10.767 0 4.315.708 7.954 2.144 10.931.289.597.597 1.167.925 1.705.065.105.124.203.19.302 1.226 1.895 2.721 3.37 4.485 4.419l1.036.518.695.341h.007c2.092.846 4.459 1.161 7.108.951 3.305-.269 6.846-1.495 10.603-3.672 3.764-2.164 7.299-5.03 10.61-8.577a64.316 64.316 0 008.63-11.653 64.242 64.242 0 005.816-13.265c1.423-4.623 2.138-9.089 2.138-13.404 0-4.314-.715-7.967-2.138-10.937zM95.197 64.882l-.99 1.712-16.643 28.708-11.56-6.59 3.81-6.564 7.75 4.42 15.364-26.506 2.223 1.273.557.314 1.023.584-1.534 2.649z"
          fill="#039855"
          stroke="#039855"
          strokeWidth={0.786885}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.732 62.233l-1.535 2.65-.99 1.71-16.642 28.709-11.561-6.59 3.81-6.564 7.75 4.42L92.93 60.062l2.222 1.272.558.314 1.023.584z"
          stroke="#039855"
          strokeWidth={0.786885}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M99.334 44.93c-1.954-.846-4.15-1.206-6.59-1.101-.118.006-.243.013-.367.026-.131.007-.27.013-.4.026-3.312.27-6.846 1.495-10.61 3.666-3.758 2.177-7.299 5.03-10.604 8.583a64.092 64.092 0 00-8.636 11.653 64.003 64.003 0 00-4.13 8.511c-.007.014-.007.02-.014.033a59.242 59.242 0 00-1.665 4.722 52.031 52.031 0 00-.735 2.603c-.006.013-.006.026-.006.04-.945 3.69-1.404 7.271-1.404 10.766 0 4.315.709 7.954 2.145 10.932.288.596.596 1.167.924 1.704.066.105.125.204.19.302 1.227 1.895 2.722 3.371 4.486 4.42l-13.115-6.558c-1.764-1.049-3.26-2.524-4.485-4.419-.4-.623-.774-1.299-1.115-2.007-1.436-2.977-2.144-6.616-2.144-10.931 0-3.508.465-7.102 1.41-10.807a60.117 60.117 0 012.413-7.357 64.003 64.003 0 014.13-8.511 64.096 64.096 0 018.637-11.653c3.305-3.554 6.846-6.407 10.603-8.584 3.764-2.17 7.298-3.396 10.61-3.665.256-.02.518-.04.767-.053 2.453-.105 4.662.263 6.623 1.115l1.24.623 11.842 5.921z"
          fill="#ECFDF3"
          stroke="#039855"
          strokeWidth={0.786885}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ProcessSuccessful;
